import { settingsApiClient } from "@api/settings-api-client";
import { createAsyncThunk } from "@reduxjs/toolkit";
/**
 * Fetches user settings in batch.
 * @throws {Error} if the Settings API client request fails
 */
export const fetchUserSettings = createAsyncThunk("settings/fetchUserSettings", async ({
  identifiers,
  userId: _userId
}) => {
  return await settingsApiClient.user.fetchUserBatchSettings(identifiers);
});
/**
 * Updates a single user setting and returns the updated setting.
 */
export const updateUserSetting = createAsyncThunk("settings/updateUserSetting", async ({
  identifier,
  userId,
  payload
}) => {
  const updatedSetting = await settingsApiClient.user.updateUserSettings(identifier, payload);
  return {
    userId,
    setting: updatedSetting
  };
});
/** Fetches company settings in batch */
export const fetchCompanySettings = createAsyncThunk("settings/fetchCompanySettings", async ({
  identifiers,
  companyId
}) => {
  return await settingsApiClient.company.fetchCompanyBatchSettings(companyId, identifiers);
});
/**
 * Updates a single company setting and returns the updated setting.
 */
export const updateCompanySetting = createAsyncThunk("settings/updateCompanySetting", async ({
  identifier,
  companyId,
  payload
}) => {
  const updatedSetting = await settingsApiClient.company.updateCompanySettings(companyId, identifier, payload);
  return {
    companyId,
    setting: updatedSetting
  };
});